import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';

@Component({
  imports: [
    CommonModule,
    MatExpansionModule
  ],
  standalone: true,
  selector: 'app-filter-section',
  templateUrl: './filter-section.component.html',
  styleUrls: ['./filter-section.component.scss']
})
export class FilterSectionComponent {
  @Input() title: string;
  @Input() expanded = false;
  @Output() onExpanded = new EventEmitter<void>();

  // Flag to track if the panel has been opened at least once
  hasBeenOpened = false;

  onPanelOpened(): void {
    if (!this.hasBeenOpened) {
      this.hasBeenOpened = true;
    }
    this.onExpanded.emit();
  }
}